import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {
	PostQuestionsAndAnswersScheduleScript,
	PostQuestionsAndAnswersScheduleScriptParams,
	PostQuestionsAndAnswersScheduleScriptResponse
} from 'domain/usecases/private/booking-flow/health/post-questions-and-answers-schedule-script';

export class RemotePostQuestionsAndAnswersScheduleScript implements PostQuestionsAndAnswersScheduleScript {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<PostQuestionsAndAnswersScheduleScriptResponse>,
	) {}

	async post(params: PostQuestionsAndAnswersScheduleScriptParams): Promise<PostQuestionsAndAnswersScheduleScriptResponse> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			body: params,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
